import { Component, Inject, Input, OnInit } from '@angular/core';
import { CaseService } from '@app/ps/services/case.service';
import { StateService } from '@uirouter/angular';
import { ListService } from '@app/common/services/list.service';
import { AuthService } from '@app/common/services/auth.service';
import { CaseStatusService } from '@app/ps/services/case-status.service';
import { Restangular } from 'ngx-restangular';
import {DialogService} from "@app/common/services/dialog.service";
import {CaseSubjectModel} from "@app/ps/models/case-subject.model";
import {SubjectDetailModel} from "@app/ps/models/subject-detail.model";

@Component({
  selector: 'update-case-ownership',
  templateUrl: './update-case-ownership.component.html',
  styleUrls: ['./update-case-ownership.component.scss']
})
export class UpdateCaseOwnershipComponent implements OnInit {

  @Input() caseOwnershipId: number;
  @Input() caseId: number;

  loading = true;
  displayFields: any = {};
  caseOwnership: any = {};
  displayFieldsLength;
  caseSubjects;

  constructor(
    private stateService: StateService,
    private listService: ListService,
    private authService: AuthService,
    private restangular: Restangular,
    private dialogService: DialogService,
  ) {
    this.onSubmit = this.onSubmit.bind(this);
    this.onSubmitAll = this.onSubmitAll.bind(this);
    this.onSubmitCase = this.onSubmitCase.bind(this);
    this.toggleSinglePayment = this.toggleSinglePayment.bind(this);
  }

  async ngOnInit() {

    const list = this.listService.createList('case-subjects', {
      limit: 3,
      filters: {
        caseOwnershipId: this.caseOwnershipId,
      }
    });

    Promise.all([
      this.restangular.one('case-ownerships', this.caseOwnershipId).get({loadCollections: 'businessCase'}).toPromise(),
      this.listService.fetchResult(list)
    ]).then((data) => {
      this.caseOwnership = data[0];

      if (this.authService.getActualProject().easementPriceByShare) {
        if (
          this.caseOwnership.businessCase.obligation.type === 'RealBurdenLiability'
        ) {
          this.displayFields.easementFutureContractNumber = true;
          this.displayFields.easementFutureContractStatus = true;
        }

        if (this.authService.hasPermission('admin,update_case_price')) {
          this.displayFields.easementPriceByShare = true;
        }
      }

      this.displayFieldsLength = Object.keys(this.displayFields).length;
      this.caseSubjects = list.list;
      this.loading = false;
    });
  }

  onSubmit(): Promise<any> {
    return this.dialogService.confirmDialogPromise('Uložení změn. Chcete uložit změny údajů nejen u tohoto případu, ale i v detailu vlastníka?')
      .then(result => {
        if (result === true) {
          return this.onSubmitAll();
        } else {
          return this.onSubmitCase();
        }
      });
  }

  onSubmitCase() {
    // save and return data to detail
    return this.restangular.one('cases', this.caseOwnership.businessCase.id).all('ownerships-subjects').customPUT({
      caseOwnerships: [this.caseOwnership.plain()],
      caseSubjects: this.caseSubjects,
    }).toPromise().then((data) => {
      this.stateService.go('^');
    });
  }

  onSubmitAll(): Promise<any> {
    const promises = [];

    promises.push(this.onSubmitCase());

    for (const caseSubject of this.caseSubjects) {
      this.assembleSubjectDetail(caseSubject.subject.subjectDetail, caseSubject);

      const promise = this.restangular
        .one(`subjects/${caseSubject.subject.id}/detail`)
        .customPUT(caseSubject.subject.subjectDetail)
        .toPromise();

      promises.push(promise);
    }

    return Promise.all(promises);
  }

  toggleSinglePayment() {
    this.caseOwnership.singlePayment = !this.caseOwnership.singlePayment;
    if (this.caseOwnership.singlePayment) {
      this.caseSubjects.forEach(this.clearPayment);
    } else {
      this.clearPayment(this.caseOwnership);
    }
  }

  clearPayment(object) {
    object.paymentType = undefined;
    object.accountNumber = null;
    object.bankCode = null;
    object.variableSymbol = null;
    object.specificSymbol = null;
    object.constantSymbol = null;
  }

  private assembleSubjectDetail(subjectDetail: SubjectDetailModel, caseSubject: CaseSubjectModel) {
    if (caseSubject.subject.opsubType === 'BSM') {
      subjectDetail.singlePayment = this.caseOwnership.singlePayment;
    }
    subjectDetail.paymentType = caseSubject.paymentType as 'X' | 'M' | 'B';
    subjectDetail.accountNumber = caseSubject.accountNumber;
    subjectDetail.bankCode = caseSubject.bankCode;
  }
}
